import { Modal } from "antd";
import { API_URL } from "env";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
const platformMapingData = [
    { key: 'MT4', name: 'MetaTrader 4', color: 'bg-blue-500' },
    { key: 'MT5', name: 'MetaTrader 5', color: 'bg-green-500' },
    { key: 'cTrader', name: 'cTrader', color: 'bg-purple-500' },
]
interface InventoryItemType {
    id: number;
    product_id: number | null;
    tool_id: number | null;
    image: string;
    botName: string;
    subTitle?: string;
    customerEmail: string;
    platform: string;
    amount: string;
    originalAmount: string;
    downloadUrl?: string;
    date: string;
    status: string;
}
interface StoreInventoryItemProps {
}

const StoreInventoryItem = (props: StoreInventoryItemProps) => {
    const [nameFillter, setNameFilter] = useState('');
    const [platformFilter, setPlatformFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState('');
    const [status, setStatus] = useState<'loading' | 'error' | 'success'>('loading');
    const [purchasedItems, setPurchasedItems] = useState<InventoryItemType[]>([]);
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null;

    function downloadFromLink(url: string, filename: string) {
        if (!url) return;
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    async function fetchInventoryItems() {
        try {
            setStatus('loading');
            if (!user || !user.id) return [];

            const response = await fetch(`${API_URL}/api/v1/be/orders?status=paid&user_id=${user.id}&limit=0`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
                },
            });

            const data = await response.json();

            if (data.status) {
                const items: InventoryItemType[] = await Promise.all(
                    data.data.items.map(async (order: any) => {
                        if (order.tool_id) {
                            const productData = await fetchProductsTool(order.tool_id);
                            return {
                                id: order.id,
                                product_id: order.product_id,
                                tool_id: order.tool_id,
                                image: productData?.image || '',
                                botName: productData?.title?.en || 'Unknown Product',
                                customerEmail: user.email || '',
                                platform: productData?.platform || 'Unknown Platform',
                                amount: order.points_paid_formatted || '',
                                originalAmount: productData?.originalAmount ? `${productData.originalAmount}` : '',
                                date: new Date(order.created_at).toLocaleString(),
                                subTitle: productData?.subtitle?.en || '',
                                status: order.status || '',
                            };
                        }
                        else if (order.product_id) {
                            return null;
                        }
                        return null;
                    })
                );

                setPurchasedItems(items.filter(Boolean) as InventoryItemType[]);
                setStatus('success');
            } else {
                setStatus('error');
                toast.error("Response not ok" + JSON.stringify(data.error || ''));
            }
        } catch (error) {
            setStatus('error');
            console.error("Failed to fetch purchased tool IDs:", error);
        }
    }

    async function fetchPaymentsData(id: number) {
        try {
            const response = await fetch(API_URL + `/api/v1/be/payments/${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
                },
            });
            const data = await response.json();
            if (data.status) {
                return data.data;
            } else {
                toast.error("Response not ok" + response.statusText);
                return null;
            }
        }
        catch (error) {
            console.error("Failed to fetch product:", error);
            return null;
        }
    }

    async function fetchProductsTool(id: number) {
        try {
            const response = await fetch(API_URL + `/api/v1/be/tools/${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
                },
            });
            const data = await response.json();
            if (data.status) {
                const locale = (lang === 'vi' ? 'vi' : 'en');
                const product: InventoryItemType = {
                    id: data.data.id,
                    product_id: data.data.id,
                    tool_id: data.data.id,
                    image: data.data.image || '',
                    botName: data.data.title?.[locale] || 'Unknown Product',
                    customerEmail: '',
                    platform: data.data.platform || 'Unknown Platform',
                    amount: data.data.price_finalize ? `$${data.data.price_finalize}` : '',
                    originalAmount: data.data.price ? `$${data.data.price}` : '',
                    downloadUrl: data.data.file_bot_url || '',
                    date: '',
                    status: '',
                };
                return {
                    ...data.data,
                    ...product
                }
            } else {
                toast.error("Response not ok" + response.statusText);
                return null;
            }
        }
        catch (error) {
            console.error("Failed to fetch product:", error);
            return null;
        }
    }

    useEffect(() => {
        fetchInventoryItems();
    }, []);

    return (
        <div className="inventory-container rounded-[3px] shadow-md overflow-hidden">
            <div className="flex justify-between items-center py-4 border-b inventory-filler border-gray-200">
                <div className="flex items-center gap-4 w-1/3">
                    <input
                        type="text"
                        placeholder={t('search_by_name_or_platform')}
                        className="border rounded px-3 py-2 w-full !text-sm text-gray-700"
                        value={nameFillter}
                        onChange={e => setNameFilter(e.target.value)}
                    />
                </div>
                <div className="flex gap-4 items-center">
                    <select
                        className="border rounded px-3 py-2 !text-sm text-gray-700"
                        value={platformFilter}
                        onChange={e => setPlatformFilter(e.target.value)}
                    >
                        <option value="">All Platforms</option>
                        <option value="MetaTrader 4">MetaTrader 4</option>
                        <option value="MetaTrader 5">MetaTrader 5</option>
                        <option value="cTrader">cTrader</option>
                    </select>
                </div>
            </div>
            <div className="overflow-x-auto">
                {
                    status === 'loading' ? (
                        <div className="p-4 text-center text-gray-500">Loading inventory items...</div>
                    ) : status === 'error' ? (
                        <div className="p-4 text-center text-red-500">Error loading inventory items. Please try again later.</div>
                    ) : (
                        <table className="w-full divide-y divide-gray-200 overflow-x-auto">
                            <thead className="inventory-table-header">
                                <tr>
                                    <th className="px-6 py-3 text-left text-xs font-medium text uppercase tracking-wider">{t('inventory_name')}</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text uppercase tracking-wider">{t('inventory_amount')}</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text uppercase tracking-wider">{t('inventory_date')}</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text uppercase tracking-wider">{t('inventory_status')}</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text uppercase tracking-wider">{t('inventory_action')}</th>
                                </tr>
                            </thead>
                            <tbody className="inventory-table divide-y divide-gray-200">
                                {purchasedItems
                                    .filter(item => {
                                        return (
                                            (nameFillter === '' || item.botName.toLowerCase().includes(nameFillter.toLowerCase()) || item.platform.toLowerCase().includes(nameFillter.toLowerCase())) &&
                                            (platformFilter === '' || item.platform === platformFilter)
                                        );
                                    })
                                    .map(item => (
                                        <tr key={item.id} className="inventory-item-card"

                                        >
                                            <td className="px-6 py-4 whitespace-nowrap"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (item.product_id) {
                                                        window.open(`/profile/inventory/${item?.product_id}`, '_self');
                                                    } else if (item.tool_id) {
                                                        window.open(`/stores/${item?.tool_id}`, '_self');
                                                    }
                                                }}
                                            >
                                                <div className="flex items-start justify-center">
                                                    <div className="h-40 w-40 rounded-lg inventory-item-card overflow-hidden bg-gray-100 relative">
                                                        <img src={item.image} alt={item.botName}
                                                            className="h-40 w-40 rounded-lg object-cover inventory-item-card"
                                                            onLoad={e => {
                                                                const target = e.currentTarget as HTMLImageElement;
                                                                target.style.transition = 'opacity 300ms ease-in';
                                                                target.style.opacity = '1';

                                                                // remove any loading placeholder/overlay if present
                                                                const placeholder = target.parentElement?.querySelector('.img-loading, .loading-svg, .loading-placeholder') as HTMLElement | null;
                                                                if (placeholder) placeholder.remove();
                                                            }}
                                                            onError={e => {
                                                                const target = e.currentTarget as HTMLImageElement;
                                                                // prevent repeated error handling
                                                                target.onerror = null;
                                                                // hide the broken image element
                                                                target.style.display = 'none';

                                                                // remove any loading placeholder/overlay if present
                                                                const placeholder = target.parentElement?.querySelector('.img-loading, .loading-svg, .loading-placeholder') as HTMLElement | null;
                                                                if (placeholder) placeholder.remove();

                                                                // only add one fallback element
                                                                if (!target.parentElement?.querySelector('.img-fallback')) {
                                                                    const fallback = document.createElement('div');
                                                                    fallback.className = "img-fallback h-full inset-0 flex items-center justify-center";
                                                                    fallback.innerHTML = `
                                                            <div class="flex flex-col items-center">
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="40" height="40" fill="none"/><path d="M104,208H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V88l-48,16-16,40-40,16Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M137.73,208l7.94-23.8,39-15.58,15.58-39,23.8-7.94V200a8,8,0,0,1-8,8Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M32,168.69l54.34-54.35a8,8,0,0,1,11.32,0l39,39" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>    
                                                                <p class="mt-2 text-sm text-gray-500">Image not available</p>
                                                            </div>    
                                                        `;
                                                                    target.parentNode?.appendChild(fallback);
                                                                }
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="ml-4 pt-2">
                                                        <div className="ml-4 mb-0 text-sm font-medium text-gray-900" style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            WebkitLineClamp: 2,
                                                            WebkitBoxOrient: 'vertical',
                                                            overflow: 'hidden',
                                                            width: '250px',
                                                            wordBreak: 'break-all'
                                                        }}>
                                                            <p className="inline-block text mb-0">{item.botName}</p>
                                                            <span className={`ml-2 inline-block px-2 py-1 text-xs font-semibold text-white rounded ${platformMapingData.find(p => p.name === item.platform)?.color || 'bg-gray-500'}`}>
                                                                {item.platform}
                                                            </span>
                                                        </div>
                                                        <p className="ml-4 mt-1 text-xs text-muted" style={{
                                                            display: '-webkit-box',
                                                            WebkitLineClamp: 2,
                                                            WebkitBoxOrient: 'vertical',
                                                            overflow: 'hidden',
                                                            width: '250px',
                                                            wordBreak: 'break-all'
                                                        }}>{item.subTitle}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm font-medium text">{item.amount}</div>
                                                <div className="text-xs text-gray-500 line-through">{item.originalAmount}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {(() => {
                                                    const d = new Date(item.date);
                                                    return (
                                                        <div>
                                                            <div className="text-sm text">{d.toLocaleDateString()}</div>
                                                            <div className="text-xs text-gray-500">{d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>
                                                        </div>
                                                    );
                                                })()}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                {item.status === 'paid' ? (
                                                    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check-circle mr-1"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><path d="m9 11 3 3L22 4"></path></svg>
                                                        Completed
                                                    </span>
                                                ) : item.status === 'pending' ? (
                                                    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-800">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-clock mr-1"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                                                        Pending
                                                    </span>
                                                ) : (
                                                    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-800">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x-circle mr-1"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
                                                        Failed
                                                    </span>
                                                )}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                                <div className="flex items-center gap-2">
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            window.location.href = `/profile/inventory/${item.id}`;
                                                        }}
                                                        className="text-blue-600 hover:text-white hover:bg-blue-500 p-2 rounded transition-all duration-300" title="View Details">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eye h-4 w-4"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            window.location.href = `/profile/inventory/${item.id}`;
                                                        }}
                                                        className="text-green-600 hover:text-green-900 hover:bg-green-500 p-2 rounded transition-all duration-300" title="Download Files">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-download h-4 w-4"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" x2="12" y1="15" y2="3"></line></svg>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    )
                }
            </div>
        </div>
    );
};

export default StoreInventoryItem;